/*
 * ProjectActivityListPage Messages
 *
 * This contains all the text for the ProjectsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects';

export default defineMessages({
  content: {
    id: `${scope}.content`,
    defaultMessage: 'Content',
  },
  defaultProjectName: {
    id: `${scope}.default.projectName`,
    defaultMessage: 'Untitled activity',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  comments: {
    id: `${scope}.comments`,
    defaultMessage: 'Comments',
  },
  owner: {
    id: `${scope}.owner`,
    defaultMessage: 'Owner',
  },
  updatedAt: {
    id: `${scope}.updatedAt`,
    defaultMessage: 'Last Modified',
  },
  dateUpdated: {
    id: `${scope}.dateUpdated`,
    defaultMessage: 'Date updated',
  },
  dateOpened: {
    id: `${scope}.dateOpened`,
    defaultMessage: 'Date opened',
  },
  createdOn: {
    id: `${scope}.createdOn`,
    defaultMessage: 'CREATED ON',
  },
  importing: {
    id: `${scope}.importing`,
    defaultMessage: 'IMPORTING',
  },
  lessonDeleteMessages: {
    cancel: {
      id: `${scope}.cancel`,
      defaultMessage: 'Cancel',
    },
    deleteItem: {
      id: `${scope}.deleteItem`,
      defaultMessage: 'Delete',
    },
    modalConfirmationTitle: {
      id: `${scope}.modalConfirmationTitle`,
      defaultMessage: 'Delete this lesson?',
    },
    modalConfirmationDescription: {
      id: `${scope}.modalConfirmationDescription`,
      defaultMessage: 'You will not be able to recover this lesson once deleted. Are you sure you want to continue?',
    },
  },
  courseDeleteMessages: {
    cancel: {
      id: `${scope}.cancel`,
      defaultMessage: 'Cancel',
    },
    deleteItem: {
      id: `${scope}.deleteItem`,
      defaultMessage: 'Delete',
    },
    modalConfirmationTitle: {
      id: `${scope}.modalConfirmationTitle`,
      defaultMessage: 'Delete this course?',
    },
    modalConfirmationDescription: {
      id: `${scope}.modalConfirmationDescription`,
      defaultMessage: 'You will not be able to recover this course once deleted. Are you sure you want to continue?',
    },
  },
});
